import { Checkbox, DatePicker, Input } from "antd";
import styled from "styled-components";
const { TextArea } = Input;

export const FieldContainer = styled.div`
	margin-bottom: 14px;
	width: 100%;
	.dynamic-input-field-label {
		padding: 8px;
		font-weight: 500;
	}
	.input__phone-container {
		display: flex;
		align-items: center;
		position: relative;
	}
	.input__select {
		height: 34px;
		position: absolute;
		left: 4px;
		border: none;
		border-radius: 20px;
		font-size: 14px;
		width: 60px;
		max-width: 60px;
		background-color: transparent;
	}
	.error-label {
		font-size: 12px;
		color: #ff4d4f;
	}
	select {
		font-weight: 200;
	}
	.opcional-label {
		color: rgb(0, 0, 0, 0.45);
	}
	.input__select-forms {
		width: 100%;
		height: 40px;
		border-radius: 8px;
		padding: 8px;

		border: ${(props) =>
			props.hasErrorInThisFiled
				? "1px solid #FF4D4F"
				: "1px solid #e6e6e6"};
		::active,
		::focus {
			border: none;
		}
		:active,
		:focus-within {
			border: 1px solid #1890ff;
		}
	}
`;

export const FieldStyled = styled.input`
	width: 100%;
	height: 40px;
	border-radius: 8px;
	padding: 8px;

	border: ${(props) =>
		props.hasErrorInThisFiled ? "1px solid #FF4D4F" : "1px solid #e6e6e6"};
	::active,
	::focus {
		border: none;
	}
	:active,
	:focus-within {
		border: 1px solid #1890ff;
	}
	padding-left: ${(props) => {
		if (props.name === "Rut/Dni") {
			return "68px";
		}
		if (props.name === "Telefono" || props.name === "Teléfono") {
			return "68px";
		}
	}};
`;

export const TextAreaStyled = styled(TextArea)`
	width: 100%;
	border-radius: 8px;
	padding: 8px;

	border: ${(props) =>
		props.hasErrorInThisFiled ? "1px solid #FF4D4F" : "1px solid #e6e6e6"};
	::active,
	::focus {
		border: none;
	}
	:active,
	:focus-within {
		border: 1px solid #1890ff;
	}
`;

export const CheckboxStyled = styled(Checkbox)`
	margin-left: 10px;
	margin-bottom: 4px;
`;

export const CheckboxGroupContainer = styled.div`
	.ant-checkbox-group {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const DatePickerStyled = styled(DatePicker)`
	width: 100%;
	border-radius: 8px;
	padding: 8px;
`;
